import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "share-menu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "button button--share",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuVisible = !_ctx.menuVisible))
  }, [
    _createTextVNode(_toDisplayString(_ctx.$t('AdShare.button-title')) + " ", 1),
    (_ctx.menuVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.networks, (network) => {
            return (_openBlock(), _createBlock(_component_ShareNetwork, {
              key: network.key,
              class: "button",
              onOpen: _ctx.open,
              network: network.network,
              url: _ctx.sharing.url,
              title: network.title ? network.title : _ctx.sharing.title,
              description: _ctx.sharing.description,
              quote: _ctx.sharing.quote,
              hashtags: _ctx.sharing.hashtags,
              twitterUser: _ctx.sharing.twitterUser,
              options: _ctx.options
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(network.icon)
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(network.name), 1)
              ]),
              _: 2
            }, 1032, ["onOpen", "network", "url", "title", "description", "quote", "hashtags", "twitterUser", "options"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, _ctx.onClickOutside]
  ])
}